import { api, headers } from '../../utils/authAxios';
import {
  intializeSuccess,
  isFeedbackRequired,
  saveLanguages,
  saveZones,
} from './actions';

export const intialize = (success, fail, token) => {
  headers["user-token"] = token;

  return (dispatch) => {
    api
      .post('/api/game/initialize',{},{headers})
      .then((res) => {
        if (res.data.error_code === 403){
          fail(res);
          return
        }
        dispatch(intializeSuccess(true));
        dispatch(saveLanguages(res.data.languageList));
        dispatch(saveZones(res.data.zoneList));
        dispatch(isFeedbackRequired(res.data.profileFeedbackRequired));
        success();
      })
      .catch((err) => {
        fail(err);
      });
  };
};
